module.exports = __webpack_public_path__ + "img/sy_company.ba032af5.png";